/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NumberCircle05Icon16Light } from './NumberCircle05Icon16Light';
import { NumberCircle05Icon16Regular } from './NumberCircle05Icon16Regular';
import { NumberCircle05Icon16Solid } from './NumberCircle05Icon16Solid';
import { NumberCircle05Icon20Light } from './NumberCircle05Icon20Light';
import { NumberCircle05Icon20Regular } from './NumberCircle05Icon20Regular';
import { NumberCircle05Icon20Solid } from './NumberCircle05Icon20Solid';
import { NumberCircle05Icon24Regular } from './NumberCircle05Icon24Regular';
import { NumberCircle05Icon24Solid } from './NumberCircle05Icon24Solid';
import { NumberCircle05Icon32Regular } from './NumberCircle05Icon32Regular';
import { NumberCircle05Icon64Regular } from './NumberCircle05Icon64Regular';
var sizes = {
    16: {
        light: NumberCircle05Icon16Light,
        regular: NumberCircle05Icon16Regular,
        solid: NumberCircle05Icon16Solid,
    },
    20: {
        light: NumberCircle05Icon20Light,
        regular: NumberCircle05Icon20Regular,
        solid: NumberCircle05Icon20Solid,
    },
    24: {
        regular: NumberCircle05Icon24Regular,
        solid: NumberCircle05Icon24Solid,
    },
    32: {
        regular: NumberCircle05Icon32Regular,
    },
    64: {
        regular: NumberCircle05Icon64Regular,
    },
};
export var NumberCircle05Icon = forwardRef('NumberCircle05Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
